const type = 'SET_LIMITS_ERROR';

const setLimitsLoading = () => ({
  type,
});

export { type };
export default setLimitsLoading;
